var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.206,
    height: 14.365,
    viewBox: "0 0 12.206 14.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10543"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10542"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91629",
    d: "M11.477 6.19h-1.021V4.074A4.15 4.15 0 0 0 6.055.242a4.152 4.152 0 0 0-4.4 3.834.6.6 0 0 0 .635.551.6.6 0 0 0 .634-.551 2.956 2.956 0 0 1 3.131-2.732 2.955 2.955 0 0 1 3.134 2.73V6.19H.64a.6.6 0 0 0-.64.546v6.394a1.5 1.5 0 0 0 1.59 1.377h8.936a1.488 1.488 0 0 0 1.579-1.377V6.736a.588.588 0 0 0-.628-.546zm-.638 6.94a.3.3 0 0 1-.313.276H1.59a.306.306 0 0 1-.324-.276V7.291h9.573z",
    transform: "translate(.05 -.192)",
    style: {
      stroke: "#6e6a65",
      strokeWidth: ".1px",
      fill: "#6e6a65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91630",
    d: "M565.518 1042.614a.518.518 0 0 0 .518-.518v-1.866a.518.518 0 1 0-1.035 0v1.866a.518.518 0 0 0 .517.518z",
    transform: "translate(-559.415 -1030.847)",
    style: {
      stroke: "#6e6a65",
      strokeWidth: ".1px",
      fill: "#6e6a65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91637",
    d: "M11.477 6.19h-1.021V4.074A4.15 4.15 0 0 0 6.055.242a4.152 4.152 0 0 0-4.4 3.834.6.6 0 0 0 .635.551.6.6 0 0 0 .634-.551 2.956 2.956 0 0 1 3.131-2.732 2.955 2.955 0 0 1 3.134 2.73V6.19H.64a.6.6 0 0 0-.64.546v6.394a1.5 1.5 0 0 0 1.59 1.377h8.936a1.488 1.488 0 0 0 1.579-1.377V6.736a.588.588 0 0 0-.628-.546zm-.638 6.94a.3.3 0 0 1-.313.276H1.59a.306.306 0 0 1-.324-.276V7.291h9.573z",
    transform: "translate(.05 -.192)",
    style: {
      stroke: "#6e6a65",
      strokeWidth: ".1px",
      fill: "#6e6a65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91638",
    d: "M-7835.7-21372.859h1.354v2.289l-1.354.242z",
    transform: "translate(7837.361 21376.462)",
    style: {
      fill: "#6e6a65"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.svg";
export { ForwardRef as ReactComponent };